export class UI {
    constructor(){
        this.init();
        this.tooltipMap();
    }

    init(){
        this.link();
        // this.pdf();
       // this.SetIdActionForm();
       this.removeTitleService();
       this.mapButtonHover();
    }
    pdf(){
        let pdfs = document.querySelectorAll('.link-pdf a');
        if (pdfs) {
            for (let pdf of pdfs) {
                pdf.setAttribute("onclick", "ga('send','event','Download','PDF', this.href);");
                pdf.setAttribute("target", "_blank");
            }
        }
    }
    link(){
        jQuery('.link-pdf a').attr('target','_blank');
    }
    SetIdActionForm() {
            var main = document.querySelector('main');
            var forms = main.querySelectorAll('form');
            forms.forEach(function(form) {
            var currentAction = form.getAttribute('action');
            var newAction = currentAction + '#' + form.getAttribute('id');
            form.setAttribute('action', newAction);
            });
    }
    checkForIE() {
        var ua = window.navigator.userAgent;
        var msie = ua.indexOf('MSIE ');
        if (msie > 0) {
            // IE 10 or older => return version number
            return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
        }
        var trident = ua.indexOf('Trident/');
        if (trident > 0) {
            // IE 11 => return version number
            var rv = ua.indexOf('rv:');
            return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
        }
        // all the other browsers
        return false;
    }
    tooltipMap() {
        jQuery(".a-region").mousemove(function(event) {
            var title = jQuery(this).attr("title");
            jQuery(".description").html(title);

            var mouseX = event.pageX;
            var mouseY = event.pageY - 50;

            jQuery(".description").css({
              top: mouseY, // Agrega un pequeño desplazamiento hacia abajo
              left: mouseX // Agrega un pequeño desplazamiento hacia la derecha
            }).show();
          });
        
          jQuery(".a-region").mouseout(function() {
            jQuery(".description").hide();
          });
    }
    removeTitleService() {
        if (jQuery(".slick--field-service-service--full").length) {
            if (jQuery(".slick--field-service-service--full").html().trim() === '') {
                jQuery(".content-title-slider-eventos").remove();
            }
        } else {
            jQuery(".content-title-slider-eventos").remove();
        }
    }

    mapButtonHover() {
        if (jQuery(".btn-region").length) {
            // jQuery(".btn-region").each(function() {
            //     var titleValue = jQuery(this).find("a").attr("title").replace("Región: ", "");
            //     jQuery(".a-region[title='" + titleValue + "']").hover(function() {
            //         jQuery(this).attr("title", titleValue);
            //     }, function() {
            //         jQuery(this).removeAttr("title");
            //     });
            // });
             // Agrega el evento hover a los elementos .btn-region
             jQuery(".btn-region a").hover(function() {
                var titleValue = jQuery(this).attr("title").replace("Región: ", "");
                // Busca y activa el hover en los elementos .a-region con el mismo título
                jQuery(".a-region[title='" + titleValue + "']").addClass("hovered");
            }, function() {
                // Elimina la clase de hover al salir del hover
                jQuery(".a-region.hovered").removeClass("hovered");
            });

        }
    }
}
